/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { CassiereCreationForm } from '../model/cassiere-creation-form';
// @ts-ignore
import { CassiereDTO } from '../model/cassiere-dto';
// @ts-ignore
import { CassiereNegoziReplaceForm } from '../model/cassiere-negozi-replace-form';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GenericResponseDTO } from '../model/generic-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { NegozioCreationForm } from '../model/negozio-creation-form';
// @ts-ignore
import { NegozioDTO } from '../model/negozio-dto';
// @ts-ignore
import { NegozioPatchForm } from '../model/negozio-patch-form';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelCassiereDTO } from '../model/paged-model-cassiere-dto';
// @ts-ignore
import { PagedModelNegozioDTO } from '../model/paged-model-negozio-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    EsercentiNegoziECassieriBackofficeServiceInterface,
    AssegnaNegoziCassiereEsercenteBackofficeRequestParams,
    CreaCassiereEsercenteBackofficeRequestParams,
    CreaNegozioEsercenteBackofficeRequestParams,
    DeleteCassiereEsercenteBackofficeRequestParams,
    DeleteNegozioEsercenteBackofficeRequestParams,
    GetCassiereEsercenteBackofficeRequestParams,
    GetNegozioEsercenteBackofficeRequestParams,
    ListCassieriEsercenteBackofficeRequestParams,
    ListNegoziEsercenteBackofficeRequestParams,
    PatchEnableCassiereEsercenteBackofficeRequestParams,
    PatchNegozioCassiereEsercenteBackofficeRequestParams,
    ReinviaAttivazioneCassiereEsercenteBackofficeRequestParams,
    UpdateNegozioEsercenteBackofficeRequestParams
} from './esercenti-negozi-e-cassieri-backoffice.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class EsercentiNegoziECassieriBackofficeService extends BaseService implements EsercentiNegoziECassieriBackofficeServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Sostituisce l\&#39;insieme dei negozi di un cassiere.
     * Replace dell\&#39;intero insieme; insieme vuoto → 422. Ogni negozio deve appartenere all\&#39;esercente (404 altrimenti). 422 esercente_bloccato se il titolare e\&#39; bloccato dall\&#39;amministrazione.
     * @endpoint put /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}/negozi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public assegnaNegoziCassiereEsercenteBackoffice(requestParameters: AssegnaNegoziCassiereEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CassiereDTO>;
    public assegnaNegoziCassiereEsercenteBackoffice(requestParameters: AssegnaNegoziCassiereEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CassiereDTO>>;
    public assegnaNegoziCassiereEsercenteBackoffice(requestParameters: AssegnaNegoziCassiereEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CassiereDTO>>;
    public assegnaNegoziCassiereEsercenteBackoffice(requestParameters: AssegnaNegoziCassiereEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling assegnaNegoziCassiereEsercenteBackoffice.');
        }
        const idCassiere = requestParameters?.idCassiere;
        if (idCassiere === null || idCassiere === undefined) {
            throw new Error('Required parameter idCassiere was null or undefined when calling assegnaNegoziCassiereEsercenteBackoffice.');
        }
        const cassiereNegoziReplaceForm = requestParameters?.cassiereNegoziReplaceForm;
        if (cassiereNegoziReplaceForm === null || cassiereNegoziReplaceForm === undefined) {
            throw new Error('Required parameter cassiereNegoziReplaceForm was null or undefined when calling assegnaNegoziCassiereEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cassieri/${this.configuration.encodeParam({name: "idCassiere", value: idCassiere, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/negozi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CassiereDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: cassiereNegoziReplaceForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea un cassiere per conto dell\&#39;esercente (onboarding via email).
     * Come il self-service con il titolare come caller logico: email &#x3D;&#x3D; quella del titolare → aggiunge al titolare l\&#39;authority CASSIERE; email di un altro utente → 422 (anti-escalation); email nuova → account inerte + mail di attivazione. L\&#39;assegnazione ai negozi e\&#39; un asse separato. 422 esercente_bloccato se il titolare e\&#39; bloccato dall\&#39;amministrazione.
     * @endpoint post /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public creaCassiereEsercenteBackoffice(requestParameters: CreaCassiereEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CassiereDTO>;
    public creaCassiereEsercenteBackoffice(requestParameters: CreaCassiereEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CassiereDTO>>;
    public creaCassiereEsercenteBackoffice(requestParameters: CreaCassiereEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CassiereDTO>>;
    public creaCassiereEsercenteBackoffice(requestParameters: CreaCassiereEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling creaCassiereEsercenteBackoffice.');
        }
        const cassiereCreationForm = requestParameters?.cassiereCreationForm;
        if (cassiereCreationForm === null || cassiereCreationForm === undefined) {
            throw new Error('Required parameter cassiereCreationForm was null or undefined when calling creaCassiereEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cassieri`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CassiereDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: cassiereCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crea un punto vendita per conto dell\&#39;esercente.
     * Come il self-service: nome/indirizzo obbligatori, normalizzati uppercase+trim. 404 se l\&#39;esercente e\&#39; fuori perimetro; 422 se nome/indirizzo blank o esercente bloccato dall\&#39;amministrazione (esercente_bloccato).
     * @endpoint post /api/v1/gestione/esercenti/profili/{profilo_id}/negozi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public creaNegozioEsercenteBackoffice(requestParameters: CreaNegozioEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<NegozioDTO>;
    public creaNegozioEsercenteBackoffice(requestParameters: CreaNegozioEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<NegozioDTO>>;
    public creaNegozioEsercenteBackoffice(requestParameters: CreaNegozioEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<NegozioDTO>>;
    public creaNegozioEsercenteBackoffice(requestParameters: CreaNegozioEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling creaNegozioEsercenteBackoffice.');
        }
        const negozioCreationForm = requestParameters?.negozioCreationForm;
        if (negozioCreationForm === null || negozioCreationForm === undefined) {
            throw new Error('Required parameter negozioCreationForm was null or undefined when calling creaNegozioEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/negozi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<NegozioDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: negozioCreationForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rimuove un cassiere (l\&#39;account resta).
     * Rimuove l\&#39;authority CASSIERE e le assegnazioni ai negozi e revoca le sessioni, senza cancellare lo User. Il titolare non puo\&#39; rimuovere se stesso come cassiere.
     * @endpoint delete /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteCassiereEsercenteBackoffice(requestParameters: DeleteCassiereEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteCassiereEsercenteBackoffice(requestParameters: DeleteCassiereEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteCassiereEsercenteBackoffice(requestParameters: DeleteCassiereEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteCassiereEsercenteBackoffice(requestParameters: DeleteCassiereEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling deleteCassiereEsercenteBackoffice.');
        }
        const idCassiere = requestParameters?.idCassiere;
        if (idCassiere === null || idCassiere === undefined) {
            throw new Error('Required parameter idCassiere was null or undefined when calling deleteCassiereEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cassieri/${this.configuration.encodeParam({name: "idCassiere", value: idCassiere, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elimina un punto vendita di un esercente.
     * Stesse regole del self-service (il cascade rimuove le assegnazioni cassiere; gli account restano).
     * @endpoint delete /api/v1/gestione/esercenti/profili/{profilo_id}/negozi/{id_negozio}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public deleteNegozioEsercenteBackoffice(requestParameters: DeleteNegozioEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteNegozioEsercenteBackoffice(requestParameters: DeleteNegozioEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteNegozioEsercenteBackoffice(requestParameters: DeleteNegozioEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteNegozioEsercenteBackoffice(requestParameters: DeleteNegozioEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling deleteNegozioEsercenteBackoffice.');
        }
        const idNegozio = requestParameters?.idNegozio;
        if (idNegozio === null || idNegozio === undefined) {
            throw new Error('Required parameter idNegozio was null or undefined when calling deleteNegozioEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/negozi/${this.configuration.encodeParam({name: "idNegozio", value: idNegozio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di un cassiere di un esercente.
     * 404 se l\&#39;esercente e\&#39; fuori perimetro o il cassiere e\&#39; di un\&#39;altra impresa.
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getCassiereEsercenteBackoffice(requestParameters: GetCassiereEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CassiereDTO>;
    public getCassiereEsercenteBackoffice(requestParameters: GetCassiereEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CassiereDTO>>;
    public getCassiereEsercenteBackoffice(requestParameters: GetCassiereEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CassiereDTO>>;
    public getCassiereEsercenteBackoffice(requestParameters: GetCassiereEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling getCassiereEsercenteBackoffice.');
        }
        const idCassiere = requestParameters?.idCassiere;
        if (idCassiere === null || idCassiere === undefined) {
            throw new Error('Required parameter idCassiere was null or undefined when calling getCassiereEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cassieri/${this.configuration.encodeParam({name: "idCassiere", value: idCassiere, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CassiereDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di un punto vendita di un esercente.
     * 404 se l\&#39;esercente e\&#39; fuori perimetro o il negozio e\&#39; di un\&#39;altra impresa.
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}/negozi/{id_negozio}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getNegozioEsercenteBackoffice(requestParameters: GetNegozioEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<NegozioDTO>;
    public getNegozioEsercenteBackoffice(requestParameters: GetNegozioEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<NegozioDTO>>;
    public getNegozioEsercenteBackoffice(requestParameters: GetNegozioEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<NegozioDTO>>;
    public getNegozioEsercenteBackoffice(requestParameters: GetNegozioEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling getNegozioEsercenteBackoffice.');
        }
        const idNegozio = requestParameters?.idNegozio;
        if (idNegozio === null || idNegozio === undefined) {
            throw new Error('Required parameter idNegozio was null or undefined when calling getNegozioEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/negozi/${this.configuration.encodeParam({name: "idNegozio", value: idNegozio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<NegozioDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elenca i cassieri di un esercente.
     * Page dei cassieri assegnati a negozi del profilo; il titolare non compare nella lista.
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listCassieriEsercenteBackoffice(requestParameters: ListCassieriEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelCassiereDTO>;
    public listCassieriEsercenteBackoffice(requestParameters: ListCassieriEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelCassiereDTO>>;
    public listCassieriEsercenteBackoffice(requestParameters: ListCassieriEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelCassiereDTO>>;
    public listCassieriEsercenteBackoffice(requestParameters: ListCassieriEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling listCassieriEsercenteBackoffice.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listCassieriEsercenteBackoffice.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cassieri`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelCassiereDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Elenca i punti vendita di un esercente.
     * Page dei negozi del profilo (Pageable standard, sort di default per nome).
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}/negozi
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listNegoziEsercenteBackoffice(requestParameters: ListNegoziEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelNegozioDTO>;
    public listNegoziEsercenteBackoffice(requestParameters: ListNegoziEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelNegozioDTO>>;
    public listNegoziEsercenteBackoffice(requestParameters: ListNegoziEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelNegozioDTO>>;
    public listNegoziEsercenteBackoffice(requestParameters: ListNegoziEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling listNegoziEsercenteBackoffice.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listNegoziEsercenteBackoffice.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/negozi`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelNegozioDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Sospende/riabilita un cassiere.
     * ?enable&#x3D;false sospende (revoca le sessioni), ?enable&#x3D;true riabilita. Il titolare non puo\&#39; sospendere se stesso come cassiere. Un cassiere bloccato dall\&#39;amministrazione non si riabilita da qui. ?enable&#x3D;true su un titolare bloccato dall\&#39;amministrazione: 422 esercente_bloccato.
     * @endpoint put /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}/enable
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public patchEnableCassiereEsercenteBackoffice(requestParameters: PatchEnableCassiereEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CassiereDTO>;
    public patchEnableCassiereEsercenteBackoffice(requestParameters: PatchEnableCassiereEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CassiereDTO>>;
    public patchEnableCassiereEsercenteBackoffice(requestParameters: PatchEnableCassiereEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CassiereDTO>>;
    public patchEnableCassiereEsercenteBackoffice(requestParameters: PatchEnableCassiereEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling patchEnableCassiereEsercenteBackoffice.');
        }
        const idCassiere = requestParameters?.idCassiere;
        if (idCassiere === null || idCassiere === undefined) {
            throw new Error('Required parameter idCassiere was null or undefined when calling patchEnableCassiereEsercenteBackoffice.');
        }
        const enable = requestParameters?.enable;
        if (enable === null || enable === undefined) {
            throw new Error('Required parameter enable was null or undefined when calling patchEnableCassiereEsercenteBackoffice.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'enable',
            <any>enable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cassieri/${this.configuration.encodeParam({name: "idCassiere", value: idCassiere, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/enable`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CassiereDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Aggiunge/rimuove un singolo negozio dallo scope del cassiere.
     * ?aggiungi&#x3D;true aggiunge (no-op idempotente se gia\&#39; presente; 422 esercente_bloccato se il titolare e\&#39; bloccato dall\&#39;amministrazione), false rimuove la coppia.
     * @endpoint patch /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}/negozi/{id_negozio}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public patchNegozioCassiereEsercenteBackoffice(requestParameters: PatchNegozioCassiereEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CassiereDTO>;
    public patchNegozioCassiereEsercenteBackoffice(requestParameters: PatchNegozioCassiereEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CassiereDTO>>;
    public patchNegozioCassiereEsercenteBackoffice(requestParameters: PatchNegozioCassiereEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CassiereDTO>>;
    public patchNegozioCassiereEsercenteBackoffice(requestParameters: PatchNegozioCassiereEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling patchNegozioCassiereEsercenteBackoffice.');
        }
        const idCassiere = requestParameters?.idCassiere;
        if (idCassiere === null || idCassiere === undefined) {
            throw new Error('Required parameter idCassiere was null or undefined when calling patchNegozioCassiereEsercenteBackoffice.');
        }
        const idNegozio = requestParameters?.idNegozio;
        if (idNegozio === null || idNegozio === undefined) {
            throw new Error('Required parameter idNegozio was null or undefined when calling patchNegozioCassiereEsercenteBackoffice.');
        }
        const aggiungi = requestParameters?.aggiungi;
        if (aggiungi === null || aggiungi === undefined) {
            throw new Error('Required parameter aggiungi was null or undefined when calling patchNegozioCassiereEsercenteBackoffice.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'aggiungi',
            <any>aggiungi,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cassieri/${this.configuration.encodeParam({name: "idCassiere", value: idCassiere, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/negozi/${this.configuration.encodeParam({name: "idNegozio", value: idNegozio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CassiereDTO>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reinvia l\&#39;email di attivazione a un cassiere.
     * Solo se l\&#39;account del cassiere non e\&#39; ancora attivato; gia\&#39; attivo o sospeso → 422. Il cassiere deve avere almeno un negozio dell\&#39;esercente (404 altrimenti).
     * @endpoint post /api/v1/gestione/esercenti/profili/{profilo_id}/cassieri/{id_cassiere}/reinvia-attivazione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public reinviaAttivazioneCassiereEsercenteBackoffice(requestParameters: ReinviaAttivazioneCassiereEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GenericResponseDTO>;
    public reinviaAttivazioneCassiereEsercenteBackoffice(requestParameters: ReinviaAttivazioneCassiereEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GenericResponseDTO>>;
    public reinviaAttivazioneCassiereEsercenteBackoffice(requestParameters: ReinviaAttivazioneCassiereEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GenericResponseDTO>>;
    public reinviaAttivazioneCassiereEsercenteBackoffice(requestParameters: ReinviaAttivazioneCassiereEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling reinviaAttivazioneCassiereEsercenteBackoffice.');
        }
        const idCassiere = requestParameters?.idCassiere;
        if (idCassiere === null || idCassiere === undefined) {
            throw new Error('Required parameter idCassiere was null or undefined when calling reinviaAttivazioneCassiereEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cassieri/${this.configuration.encodeParam({name: "idCassiere", value: idCassiere, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/reinvia-attivazione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GenericResponseDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifica un punto vendita di un esercente.
     * PUT-replace di nome/indirizzo con optimistic lock (409 su version stale). 422 esercente_bloccato se il titolare e\&#39; bloccato dall\&#39;amministrazione.
     * @endpoint put /api/v1/gestione/esercenti/profili/{profilo_id}/negozi/{id_negozio}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public updateNegozioEsercenteBackoffice(requestParameters: UpdateNegozioEsercenteBackofficeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<NegozioDTO>;
    public updateNegozioEsercenteBackoffice(requestParameters: UpdateNegozioEsercenteBackofficeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<NegozioDTO>>;
    public updateNegozioEsercenteBackoffice(requestParameters: UpdateNegozioEsercenteBackofficeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<NegozioDTO>>;
    public updateNegozioEsercenteBackoffice(requestParameters: UpdateNegozioEsercenteBackofficeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const profiloId = requestParameters?.profiloId;
        if (profiloId === null || profiloId === undefined) {
            throw new Error('Required parameter profiloId was null or undefined when calling updateNegozioEsercenteBackoffice.');
        }
        const idNegozio = requestParameters?.idNegozio;
        if (idNegozio === null || idNegozio === undefined) {
            throw new Error('Required parameter idNegozio was null or undefined when calling updateNegozioEsercenteBackoffice.');
        }
        const negozioPatchForm = requestParameters?.negozioPatchForm;
        if (negozioPatchForm === null || negozioPatchForm === undefined) {
            throw new Error('Required parameter negozioPatchForm was null or undefined when calling updateNegozioEsercenteBackoffice.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/esercenti/profili/${this.configuration.encodeParam({name: "profiloId", value: profiloId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/negozi/${this.configuration.encodeParam({name: "idNegozio", value: idNegozio, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<NegozioDTO>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: negozioPatchForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
